import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Http from "../../Http";
import { Loan_API } from "../../Helper";

import { motion } from "framer-motion";
import {
  FaCalendarAlt,
  
  FaFileInvoiceDollar,
 
  FaExclamationTriangle,

  FaUniversity,

  FaBalanceScale,
  FaBook,
  FaTractor,
  FaExchangeAlt,
  FaLock,
  FaMoneyBillWave,
  FaMoneyCheckAlt,
  FaWallet,FaShieldAlt,
  FaUserFriends,
  FaCreditCard,
  FaBookOpen,
  FaClock,
  FaMotorcycle, 
  FaRedo,
  FaBolt,
  FaPercentage
} from "react-icons/fa";
import { GiGoldBar } from "react-icons/gi";
import { FaUser,  FaStar } from "react-icons/fa";
import {
    FaBirthdayCake ,
    FaBriefcase,
    FaUserCheck,
    FaChartLine,
    FaHome,
    FaIdCard,
    FaUnlock,
    FaRupeeSign,
    FaPercent
} from "react-icons/fa";

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const GoldLoanNew = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [loanData, setLoanData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const faqs = [
    {
        question: ' What is a gold loan and how does it work?',
        answer:
            ' A gold loan is a secured loan where you pledge your gold ornaments or coins as collateral in exchange for funds. The lender assesses the value of your gold and disburses a loan amount, typically up to 75% of its market value, as per RBI guidelines. You repay the loan over a chosen tenure, and your gold is returned once repayment is complete.',
    },
    {
        question: 'How much loan can I get against my gold?',
        answer:
            ' As per current RBI regulations, lenders can offer up to 75% of the market value of your gold. The exact loan amount depends on the purity and weight of your gold, as well as the lenders valuation policies. For example, if your gold is worth ₹1,00,000, you may receive up to ₹75,000 as a loan.',
    },
    {
        question: ' What are the interest rates on gold loans?',
        answer:
            ' Gold loan interest rates typically range from 7% to 16% per annum, depending on the lender, loan amount, repayment tenure, and your credit profile. Banks may offer lower rates, while NBFCs might have slightly higher rates but more flexible terms.',
    },
    {
        question: 'What is the repayment tenure for a gold loan?',
        answer:
            '  Gold loans generally offer flexible repayment tenures ranging from a few months to up to 36 months. Some lenders provide bullet repayment options, while others offer EMI-based repayment plans. You can choose the tenure that best fits your financial situation.',
    },
    {
      question: 'Can I get a gold loan through TheFinMaster.com?',
      answer:
          '  TheFinMaster.com is not a gold loan provider. We offer expert-curated educational content, lender comparison tools, and unbiased insights to help you explore various gold loan options. Once you’ve identified the most suitable lender and offer, you’ll be redirected to the lender’s official website to complete the secure loan application process.',
  },
  {
    question: "What documents are required to apply for a gold loan?",
    answer:
      "To apply for a gold loan, you typically need proof of identity (Aadhar, PAN), proof of address (utility bills, rent agreement), and the gold items you wish to pledge. Lenders may also ask for income proof if you're applying for a higher loan amount.",
  },
  {
    question: "Is my gold safe when I apply for a gold loan?",
    answer:
      "Yes, your gold is kept secure by the lender in a safe vault during the loan tenure. Most lenders also provide insurance coverage for the gold, ensuring its safety in case of theft or damage during the loan period.",
  },
  {
    question: "How is the value of my gold determined for a loan?",
    answer:
      "The value of your gold is determined based on its weight, purity (carat), and the prevailing market price of gold. Lenders usually offer a loan that is a percentage of the gold's value, commonly ranging from 60% to 90%.",
  },
  {
    question: "What happens if I miss a payment on my gold loan?",
    answer:
      "If you miss a payment on your gold loan, the lender may charge a late fee and report the missed payment to credit bureaus. After a certain period of default, the lender may auction your gold to recover the loan amount.",
  },
  {
    question: "Can I repay my gold loan early?",
    answer:
      "Yes, you can repay your gold loan early without any penalty. However, some lenders may charge a nominal fee for early repayment, so it’s advisable to check the terms of the loan agreement before proceeding with early repayment.",
  },
  {
    question: "Is there a minimum or maximum amount I can borrow against my gold?",
    answer:
      "The minimum loan amount for a gold loan typically starts at ₹10,000, but this can vary depending on the lender. The maximum loan amount depends on the value of the gold pledged and can go up to ₹10 lakhs or more, depending on the gold’s weight and purity.",
  },
  {
    question: "Can I get a gold loan without a credit score check?",
    answer:
      "Yes, most gold loans are secured loans, meaning your credit score is not a major factor in loan approval. The loan is primarily based on the value of the gold you pledge, so even individuals with low or no credit scores can typically avail of gold loans.",
  },
  {
    question: "Is it possible to get a gold loan for gold coins or bars?",
    answer:
      "Yes, you can avail of a gold loan by pledging gold coins, bars, or jewelry. However, some lenders may have specific policies regarding the type of gold (e.g., jewelry may be more commonly accepted), and the purity of the gold will be a factor in determining the loan amount.",
  },
  {
    question: "Can I apply for a gold loan if I have no income?",
    answer:
      "Yes, gold loans do not require income proof as they are secured loans. Your eligibility is primarily based on the gold’s value, so even individuals without a regular income can apply for a gold loan, as long as they have sufficient gold to pledge.",
  },
  {
    question: "What is the loan-to-value ratio (LTV) for a gold loan?",
    answer:
      "The loan-to-value (LTV) ratio for a gold loan typically ranges from 60% to 90%. This means you can borrow up to 90% of the value of the gold, depending on the lender and market conditions. LTV may vary based on the purity and type of gold pledged.",
  },
  {
    question: "Can I apply for a gold loan if I am not employed?",
    answer:
      "Yes, gold loans are not dependent on employment status. As long as you have gold to pledge and meet the lender's requirements, you can apply for a gold loan. Your eligibility is determined more by the value of the gold than your employment status.",
  },
  {
    question: "Can I get a gold loan for a short tenure?",
    answer:
      "Yes, gold loans are flexible, and you can choose a repayment tenure that suits you. Loan tenures typically range from 3 months to 36 months. If you prefer a short tenure, you can opt for a quick repayment plan, though your EMIs will be higher.",
  },
  {
    question: "Is there any prepayment penalty on gold loans?",
    answer:
      "Most lenders do not charge prepayment penalties on gold loans, as they are secured loans. However, it is always a good idea to check the specific terms and conditions with your lender before making early repayments to avoid any potential fees.",
  },
];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    fetchLoanData();
  }, []);
  const fetchLoanData = async () => {
    try {
      const response = await Http.get(Loan_API);

      // The response structure might have nested data
      // Check if response has an insurance property (like in the original fetch response)
      const data = response.loan || response;

      // Filter the insurance data to show only Car category
      const carLoanData = Array.isArray(data)
        ? data.filter((insurance) => insurance.category_name === "Gold Loan")
        : [];

      setLoanData(carLoanData);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch Loan data");
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };
  const loanTypes = [
    {
      name: "New Two-Wheeler Loan 🏍️",
      description:
        "A standard loan provided to individuals looking to purchase a brand-new bike or scooter. Lenders typically finance up to 90-100% of the on-road price, depending on the borrower's profile and lender policies.",
      icon: <FaMotorcycle />,
    },
    {
        name: "Two-Wheeler Loan with No Down Payment 💳",
        description:
          " Some banks and NBFCs offer zero down payment loans, where 100% of the bike's cost is financed, reducing the need for an upfront payment. However, such loans may come with higher interest rates or stricter eligibility criteria.",
        icon: <FaCreditCard />,
      },
      {
        name: "Two-Wheeler Loan for Bad Credit Holders ⚠️",
        description:
          "Special financing options for individuals with low or no credit scores. These loans may require a higher interest rate, additional guarantors, or collateral security.",
        icon: <FaExclamationTriangle />,
      },
    {
      name: "Used Two-Wheeler Loan 🔄",
      description:
        "Designed for purchasing pre-owned bikes or scooters, these loans generally have a lower loan-to-value (LTV) ratio, covering up to 75-80% of the bike’s valuation. Interest rates may be slightly higher due to the depreciated value of used vehicles.",
      icon: <FaRedo />,
    },
   
   

    {
      name: "Electric Two-Wheeler Loan ⚡",
      description:
        " With the growing focus on sustainable transportation, many lenders offer loans specifically for electric two-wheelers. These loans may come with lower interest rates, government subsidies, or incentives to encourage eco-friendly vehicle adoption.",
      icon: <FaBolt />,
    },

  
  ];

    const benefitshealth = [
        {
            title: "New Two-Wheeler Loan",
            description:
              "A standard loan provided to individuals looking to purchase a brand-new bike or scooter. Lenders typically finance up to 90-100% of the on-road price, depending on the borrower's profile and lender policies.",
            icon: <FaMotorcycle className="text-4xl text-blue-600" />,
          },
       
          {
            title: "Used Two-Wheeler Loan",
            description:
              " Designed for purchasing pre-owned bikes or scooters, these loans generally have a lower loan-to-value (LTV) ratio, covering up to 75-80% of the bike’s valuation. Interest rates may be slightly higher due to the depreciated value of used vehicles.",
            icon: <FaRedo className="text-4xl text-green-600" />,
          },
          {
            title: "Electric Two-Wheeler Loan",
            description:
              " With the growing focus on sustainable transportation, many lenders offer loans specifically for electric two-wheelers. These loans may come with lower interest rates, government subsidies, or incentives to encourage eco-friendly vehicle adoption.",
            icon: <FaBolt className="text-4xl text-purple-600" />,
          },
          
          {
            title: "Two-Wheeler Loan for Bad Credit Holders",
            description:
              " Special financing options for individuals with low or no credit scores. These loans may require a higher interest rate, additional guarantors, or collateral security.",
            icon: <FaExclamationTriangle  className="text-4xl text-red-600" />,
          },
            {
              title: "Two-Wheeler Loan with No Down Payment",
              description:
                " Some banks and NBFCs offer zero down payment loans, where 100% of the bike's cost is financed, reducing the need for an upfront payment. However, such loans may come with higher interest rates or stricter eligibility criteria.",
              icon: <FaCreditCard className="text-4xl text-orange-600" />,
            },
            
            
          ];







  const points = [
    {
      description: ` Quick disbursal with minimal documentation.`,
    },
    {
      description: ` Lower interest rates compared to personal loans.`,
    },
    {
      
      description: ` Flexible repayment option.`,
    },
    {
     
      description: ` No need for high credit score.`,
    },
    
  ];
  const points1 = [
    {
   
      description: `Risk of losing gold if loan is not repaid.`,
    },
    {
    
      description: ` Fluctuations in gold prices may impact LTV ratio.`,
    },
    {

      description: `Limited to the value of the gold owned by the borrower.`,
    },
    // {
    //   title: "Depreciation Impact ",
    //   description: ` The bike's value depreciates over time, reducing resale value while the loan is still being repaid.`,
    // },
 
  ];

  const points3 = [
    {
      title: " Compare Interest Rates & Loan-to-Value (LTV) Ratio",
      points: [
        "The interest rate and LTV ratio are the two most important factors that determine the cost and amount of the loan you can avail of against your gold.",
        
      ],
      
    },
    {
        points: [
    "Interest Rates: Different lenders offer varying interest rates for gold loans, typically ranging from 7% to 29% per annum. The interest rate depends on factors such as the loan tenure, repayment method, and the borrower's creditworthiness.",
        ],
    },
    
    {
      points: [
        "LTV Ratio: The Loan-to-Value (LTV) ratio determines the percentage of the gold’s market value that you can get as a loan. The RBI allows up to 75% LTV, meaning that if your gold is worth ₹1 lakh, you can get a maximum loan of ₹75,000. However, some lenders offer lower LTV ratios (60-70%) to reduce their risk.",
     
      ],
    },
    {
  
      points: [
        "Fixed vs. Floating Interest Rates: Some lenders offer fixed rates, while others provide floating rates that fluctuate with market conditions. If gold prices drop, your loan amount may be affected in a floating rate scenario.",
      ],
    },
    {
      title: " Check Repayment Flexibility",
      points: [
        "Gold loans come with multiple repayment options, allowing borrowers to choose the method that suits them best. Opting for a lender with flexible repayment structures can significantly ease financial pressure. The common repayment modes include:",
      ],
    },
    {
      
      points: [
        "Regular EMI (Equated Monthly Installment): This method allows borrowers to repay both principal and interest in fixed monthly payments over the loan tenure. Ideal for salaried individuals with steady income.",
      ],
    },
    {
         points: [
        "Interest-Only Payment: Some lenders allow you to pay only the interest during the loan tenure and repay the principal at the end. This method reduces immediate financial burden.",
      ],
    },
    {
    
      points: [
        "Bullet Repayment: Borrowers can pay the entire principal and interest at the end of the tenure, making it suitable for those expecting a lump sum inflow of cash.",
      ],
    },
    {

      points: [
        "Overdraft Facility: Some banks offer an overdraft facility where the borrower can withdraw only the amount they need from an approved loan limit, and interest is charged only on the utilized portion..",
      ],
    },
    {
        title: " Processing Fees & Hidden Charges",
        points: [
          "While interest rates are a major cost factor, processing fees and hidden charges can add to the overall loan expense. Check for:",
        ],
      },
      {
        
        points: [
          "Processing Fees: Some lenders charge 0.5% to 2% of the loan amount as a processing fee, while others offer zero processing fees for certain loan amounts.",
        ],
      },
      {
           points: [
          "Valuation Charges: Lenders may charge a valuation fee to assess the purity and weight of gold. This fee varies across banks and NBFCs.",
        ],
      },
      {
      
        points: [
          "Late Payment Penalties: Missing EMI payments can attract penalty charges of up to 3% per month on overdue amounts.",
        ],
      },
      {
  
        points: [
          "Prepayment & Foreclosure Charges: Some lenders charge 1-2% on prepayments, while others allow free early closure of the loan.",
        ],

      },
      {
      points: [
        "Gold Appraisal Charges: Lenders may impose gold purity testing charges, adding to the overall cost.",
      ],
    },
   
    
     {
        title: " Gold Storage & Security",
        points: [
          "Since you are pledging your gold ornaments, bars, or coins as collateral, ensuring safe storage and security is crucial.",
        ],
      },
      {
        
        points: [
          "Safe Vault Storage: Reputed banks and NBFCs store pledged gold in secure, insured vaults with high-level security and surveillance systems.",
        ],
      },
      {
           points: [
          "Insurance Coverage: Some lenders offer insurance for your pledged gold against theft, loss, or damage. However, this may come with additional charges.",
        ],
      },
      {
      
        points: [
          "Loan Closure & Gold Retrieval: Understand the process of retrieving your gold after loan repayment. Ensure that the lender provides a hassle-free, secure return process.",
        ],
      },
      {
  
        points: [
          "Gold Tracking & Transparency: Some lenders provide online tracking portals where you can check the status of your pledged gold.",
        ],

      },
      {
        title: " Loan Disbursal Speed",
        points: [
          "One of the major advantages of gold loans is their quick processing and disbursal, making them ideal for urgent financial needs.",
        ],
      },
      {
        
        points: [
          "Instant Loan Approval: Many banks and NBFCs offer instant loan approval within 30 minutes to a few hours.",
        ],
      },
      {
           points: [
          "Minimal Documentation: Since a gold loan is a secured loan, most lenders require only basic KYC documents (Aadhaar, PAN, or voter ID) without extensive income proof.",
        ],
      },
      {
      
        points: [
          "Online Loan Processing: Some lenders now offer fully digital gold loans, allowing customers to apply and get disbursal without visiting a branch.",
        ],
      },
      {
  
        points: [
          "Doorstep Gold Loan Services: Some NBFCs provide doorstep gold valuation and loan disbursal, making it convenient for borrowers.",
        ],

      },
      {
        title: " Prepayment & Foreclosure Terms",
        points: [
          "Gold loans usually have short tenures ranging from 3 to 36 months, and borrowers often prefer to repay the loan early if possible. However, some lenders impose foreclosure charges.",
        ],
      },
      {
        
        points: [
          "Prepayment Charges: Some lenders charge 1-2% of the outstanding loan amount if you repay before the scheduled tenure.",
        ],
      },
      {
           points: [
          "No Prepayment Penalty: Several banks allow zero prepayment charges after a specific lock-in period (3-6 months).",
        ],
      },
      {
      
        points: [
          "Foreclosure Charges: Some lenders impose a small penalty (0.5% to 1%) if you close the loan before the agreed tenure.",
        ],
      },
      {
  
        points: [
          "Part-Payment Facility: Some lenders allow part-prepayments without penalty, which helps in reducing the interest burden.",
        ],

      },
     
  ];

  const eligibilityCriteria = [
    {
        title: "Bullet Repayment Gold Loan",
        points: [
          "In this loan type, borrowers pay only the interest during the tenure and repay the principal amount in a lump sum at the end of the loan term.",
          "Preferred by self-employed individuals or business owners who anticipate a bulk inflow of funds in the future."
        ],
        icon:  <FaMoneyCheckAlt className="text-orange-500 text-2xl" />,
      },
      {
        title: "Overdraft Gold Loan",
        points: [
          "This type allows borrowers to withdraw funds as needed, up to the sanctioned loan limit, and pay interest only on the amount used.",
          "Ideal for individuals with fluctuating financial needs, such as business owners managing cash flow."
        ],
        icon: <FaExchangeAlt className="text-orange-500 text-2xl" />,
      },
    {
      title: "Short-Term Gold Loan",
      points: [
        " These are loans with a tenure of up to 12 months, primarily for individuals who need immediate funds and plan to repay the loan quickly.",
        " Interest rates for short-term loans are usually lower due to a shorter repayment period.",
      "Suitable for urgent expenses like medical emergencies, business needs, or educational costs."
    ],
      icon: <FaClock  className="text-blue-500 text-2xl" />,
    },
    {
        title: "Long-Term Gold Loan",
        points: [
          "These loans have a repayment tenure ranging from 1 to 5 years, allowing borrowers more time to repay.",
          "The interest rate may be slightly higher than short-term loans but provides financial flexibility.",
          "Ideal for individuals who require a larger loan amount and a structured repayment plan."
        ],
        icon: <FaCalendarAlt className="text-orange-500 text-2xl" />,
      },
     
        {
            title: "Agricultural Gold Loan)",
            points: [
              " Offered specifically to farmers and agricultural workers at subsidized interest rates.",
              "Helps farmers meet farming expenses, purchase equipment, or invest in crops.",
              "Usually comes with relaxed repayment terms aligned with the crop cycle."
            ],
            icon: <FaTractor className="text-purple-500 text-2xl" />,
          },
    
  ];
  const componentsData1 = [
    {
        title: "Processing Fee",
        icon: <FaChartLine className="text-2xl text-blue-600" />,
        points: [
          "Generally ranges from 0.5% to 2% of the loan amount, though some lenders offer zero processing fees for specific schemes.",
        ],
      },
  
      {
        title: "Prepayment & Foreclosure Charges",
        icon: <FaUnlock className="text-2xl text-purple-600" />,
        points: [
          "Many lenders allow prepayment without extra charges, but some may impose a 1% to 2% penalty on foreclosure.",
        ],
      },
      {
        title: "Loan-to-Value (LTV) Ratio",
        icon: <FaBalanceScale  className="text-2xl text-red-600" />,
        points: [
          "As per RBI regulations, lenders can provide a maximum of 75% of the gold’s market value as a loan.",
          
        ],
      },
      {
        title: "Gold Security & Storage",
        icon: <FaLock  className="text-2xl text-red-600" />,
        points: [
          " The pledged gold is stored securely in bank vaults or lockers and returned to the borrower upon full repayment.",
         
        ],
      },
    {
        title: "Loan Tenure",
        icon: <FaWallet className="text-2xl text-green-600" />,
        points: [
          "Ranges from a few months to several years, usually between 3 months and 5 years.",
          "Shorter tenures often come with lower interest rates.",
        ],
      },
      {
        title: " Interest Rate",
        icon: <FaPercent className="text-2xl text-yellow-600" />,
        points: [
          "Gold loans generally have lower interest rates compared to personal loans, ranging from 7% to 29% per annum, depending on the lender and loan tenure.",
          "NBFCs often charge slightly higher interest rates compared to banks.",
        ],
      },
    {
        title: "Loan Amount",
        icon: <FaRupeeSign className="text-2xl text-pink-600" />,
        points: [
          "Determined by the weight, purity, and current market value of the pledged gold.",
         "Lenders typically offer between 65% to 75% of the gold’s value as the loan amount."
        ],
      },
  
   
    

    {
      title: "Repayment Options",
      icon: <FaUserCheck className="text-2xl text-indigo-600" />,
      points: [
        "EMI-based repayment: Fixed monthly installments covering both interest and principal.",
        "Bullet repayment: Interest paid periodically, with principal repayment at loan maturity.",
        "Overdraft facility: Borrowers can repay as per their cash flow needs."
      ],
    },
 

   
    
  ];
  const comparisonData2 = [
    {
      feature: "Purpose",
      icon: <FaBook className="w-4 h-4 inline-block text-blue-500 mr-1" />,
      educationLoan:
        "Specifically for educational expenses (tuition, books, living costs, etc.)",
      personalLoan: "Can be used for any purpose, including education",
    },
    {
      feature: "Interest Rate",
      icon: (
        <FaPercentage className="w-4 h-4 inline-block text-green-500 mr-1" />
      ),
      educationLoan: "Lower interest rates (typically 8-12%)",
      personalLoan: "Higher interest rates (10-24%)",
    },
    {
      feature: "Loan Amount",
      icon: (
        <FaMoneyBillWave className="w-4 h-4 inline-block text-purple-500 mr-1" />
      ),
      educationLoan:
        "Higher amounts offered, covering up to 100% of tuition fees",
      personalLoan: "Limited based on the borrower's creditworthiness",
    },
    {
      feature: "Repayment Start",
      icon: <FaClock className="w-4 h-4 inline-block text-yellow-500 mr-1" />,
      educationLoan:
        "Repayment starts after course completion + moratorium period",
      personalLoan: "Repayment starts immediately after loan disbursal",
    },
    {
      feature: "Collateral Requirement",
      icon: <FaLock className="w-4 h-4 inline-block text-pink-500 mr-1" />,
      educationLoan: "Required for higher loan amounts (above ₹7.5 lakh)",
      personalLoan:
        "Generally unsecured, but higher loan amounts may need collateral",
    },
    {
      feature: "Tax Benefits",
      icon: (
        <FaFileInvoiceDollar className="w-4 h-4 inline-block text-rose-500 mr-1" />
      ),
      educationLoan:
        "Interest payments qualify for tax deductions under Section 80E of the IT Act",
      personalLoan: "No tax benefits",
    },
    {
      feature: "Co-Applicant Requirement",
      icon: (
        <FaUserFriends className="w-4 h-4 inline-block text-indigo-500 mr-1" />
      ),
      educationLoan: "Mandatory co-applicant (parent/guardian/spouse)",
      personalLoan:
        "Not required unless borrower has low income or poor credit history",
    },
  ];

  return (
    <>
        <Helmet>
            <title>Bike Loan – Attractive Interest Rates, EMI for Two-Wheeler Loans in India 2024 - Thefinmaster</title>
            <meta  name='description' content='Get bike loan with instant approval from top banks in India with best EMI, Interest Rates for two-wheeler purchase at Thefinmaster.'/>
            <meta name='keywords' content='motor bike loan, two wheeler loan interest rate, second hand bike loan, 0 interest two wheeler loan, bike loan apply online' />
            <link rel="canonical" href="gold_loan" />
            <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
            <meta name="robots" content="max-video-preview:-1" />
          </Helmet>
          <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
            <ol className="list-none p-0 inline-flex">
              <li className="flex items-center">
                <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
                <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
                </svg>
              </li>
                <li className="flex items-center">
                <span className="text-gray-500 ">Gold Loan</span>
              </li>  
              
            </ol>
          </nav>
            <div className="w-full flex flex-col items-center">
              <div className="w-full flex justify-center">
                <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
                  <div className="w-full sm:w-[50%]">
                    <div className="w-[90%]">
                      <h1 className="text-4xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-0 pl-6">
                        <span className="text-blue-600 ">
                        Get quick funds by pledging your gold today
                        </span>{" "}
                        easy process, instant approvals, low interest rates, and complete peace of mind
                      </h1>
                      {/* <a href="#insurance_plans">
                        <button className="py-4 px-8  border rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl text-lg mt-10 font-medium">
                          See Plans
                        </button>
                      </a> */}
                    </div>
                  </div>
                  <div className="w-full sm:w-[50%]">
                    <img
                      className="w-full max-w-full"
                      src="/assets/gold.png"
                      alt="Two Wheeler-loan"
                    />
                  </div>
                </div>
             </div>
      
             </div>
             <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
          <p className="text-lg md:text-base lg:text-lg text-center">
          When you need quick access to funds, TheFinMaster.com helps you leverage the value of your gold with ease. Our platform brings you a curated selection of gold loan offers from trusted lenders, allowing you to compare interest rates, loan tenures, and repayment options effortlessly. Whether it's for personal needs, emergencies, or business use, TheFinMaster.com makes securing a gold loan fast, transparent, and stress-free.  </p>
              </div>
              <div className="container mx-auto">
      <div className="flex flex-col lg:flex-row">
      <div className="w-full lg:w-3/4">
      <div id="loan_plans" className="lg:pr-6 md:px-4 px-2">
      {loading ? (
              <div className="text-center py-10">Loading Loan options...</div>
            ) : error ? (
              <div className="text-center py-10 text-red-600">{error}</div>
            ) : loanData.length === 0 ? (
              <div className="text-center py-10">
                No Gold Loan options available at the moment.
              </div>
            ) : (loanData.map((loan) => (
            <div
              key={loan.id}
              className="md:w-full max-w-[900px] py-2 border shadow-lg overflow-hidden hover:shadow-xl rounded-lg flex flex-wrap md:flex-nowrap gap-5 justify-between mx-auto mt-4"
            >
              <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center md:justify-normal">
                <Link to={`/gold_loan/${loan.page_url}`}>
                  <div className="w-[95%] md:w-[220px] overflow-hidden py-2 md:ml-2">
                    <img
                      className="w-full h-full object-contain"
                      alt={loan.page_title || "Loan Provider"}
                      src={loan.image}
                    />
                  </div>
                </Link>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Interest Rate</p>
                <h4 className="text-2xl py-0.5 font-bold">
                  {loan.interest_rate}%
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Loan Amount </p>
                <h4 className="text-2xl py-0.5 font-bold">
                  ₹{loan.loan_amount}
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Processing Fee</p>
                <h4 className="text-2xl py-0.5 font-bold">
                  ₹{loan.processing_fee}
                </h4>
              </div>

              <div className="flex flex-wrap justify-center md:justify-between items-center my-5 w-full gap-2 px-4">
                <a
                  href={loan.bank_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-green-500 text-white font-semibold py-2 px-4 rounded hover:bg-green-600 transition duration-300">
                    Get Quote!
                  </button>
                </a>

                <Link to={`/gold_loan/${loan.page_url}`}>
                  <button className="text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500">
                    See Details
                  </button>
                </Link>
              </div>
            </div>
          ))
        )}
        </div>
</div>
<div className="w-full lg:w-1/4 px-2 md:px-4 mt-6 lg:mt-0">
          <div className="sticky top-20">
            {/* Ad 1 - Visible on all screen sizes */}
            <a href="https://play.google.com/store/apps/details?id=com.myairtelapp&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="block">
              <img 
                src="/assets/sidebanner.png" 
                alt="Insurance Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a>
            
            {/* Ad 2 - Hidden on small mobile, visible on larger screens */}
            {/* <a href="https://example.com/premium-discount" target="_blank" rel="noopener noreferrer" className="hidden sm:block mt-6">
              <img 
                src="/assets/niyoo.png" 
                alt="Premium Discount Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
            
            {/* Compact ad for mobile only */}
            {/* <a href="https://example.com/mobile-offer" target="_blank" rel="noopener noreferrer" className="block sm:hidden mt-4">
              <img 
                src="/assets/niyoo.png" 
                alt="Mobile Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
          </div>
        </div>
      </div>
    </div>

      <div className="flex justify-center items-center  p-4 mt-10">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
          What is a Gold Loan?
          </h2>
          <p className="text-gray-600 leading-relaxed">
          A gold loan is a secured loan where individuals pledge their gold ornaments, coins, or jewelry as collateral to a bank or non-banking financial company (NBFC) in exchange for funds. These loans provide a quick and convenient way to access liquidity while ensuring the borrower's gold assets remain intact. Gold loans are popular in India due to the high cultural and financial value of gold in Indian households.


          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
          Unlike unsecured loans like personal loans, a gold loan typically offers lower interest rates due to its secured nature. The loan amount is determined based on the weight and purity of the gold, with lenders offering up to 75% of the gold's market value, as per RBI regulations. The repayment tenure can vary from a few months to a few years, making it a flexible borrowing option for urgent financial needs.          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
        Key Stats of Gold Loan in India
        </h2>
        {/* <p className="text-gray-600 text-sm md:text-base mt-2">
          Choosing the right car insurance is crucial for financial security on
          the road. Here are the three main types of car insurance plans:
        </p> */}

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
        <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">📊</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
            Market Growth
            </h3>
            <p className="text-gray-700 text-sm mt-1">
            The Indian gold loan market is expected to reach INR 4.5 trillion by 2025, growing at a CAGR of approximately 13% from 2022. This growth is driven by increasing demand for quick and hassle-free loans.

            </p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">💰</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
            Loan Disbursement
            </h3>
            <p className="text-gray-700 text-sm mt-1">
            In FY 2023, gold loan disbursement by NBFCs alone crossed INR 2.5 trillion, reflecting the rising preference for gold-backed credit among borrowers.

            </p>
          </div>

       

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">⚖️</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
            Average Loan-to-Value (LTV) Ratio
            </h3>
            <p className="text-gray-700 text-sm mt-1">
            As per RBI guidelines, lenders offer up to 75% of the gold's value as a loan. However, some lenders provide a lower LTV to mitigate risk, especially during periods of gold price volatility.


            </p>
          </div>
        </div>
      </div>
    


    




      <div className="max-w-7xl mx-auto px-4 py-12">
        <h2 className="text-3xl font-bold text-center mt-16 mb-6">
        Types of Gold Loans
        </h2>
        <p className="text-gray-600 text-center mb-8">
        Gold loans are categorized based on various factors, such as tenure, repayment method, and interest rates. Here are the primary types:
        </p>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-8">
          {eligibilityCriteria.map((criteria, index) => (
            <div
              key={index}
              className="p-6 bg-gray-100 shadow-md rounded-2xl hover:shadow-lg transition-all duration-300 flex items-start gap-4"
            >
              <div className="w-12 h-12 flex items-center justify-center  text-8xl">
        {criteria.icon}
      </div>
              <div>
                <h3 className="font-semibold text-lg mb-2">{criteria.title}</h3>
                <ul className="list-disc list-inside text-gray-600 text-md">
                  {criteria.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-10">
        <h2 className="text-3xl font-bold text-center mb-6">
        Key Components of a Gold Loan
        </h2>
        {/* <p className="text-center text-gray-600 mb-10">
        To avail of a two-wheeler loan, applicants must meet certain eligibility criteria set by financial institutions. The requirements may vary slightly among lenders, but the general criteria are as follows:

        </p> */}

        <div className="grid md:grid-cols-2 gap-8">
          {componentsData1.map((item, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md p-5 hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start gap-4 mb-3">
                {item.icon}
                <h3 className="text-lg font-semibold">{item.title}</h3>
              </div>
              <ul className="list-disc list-inside text-gray-700 space-y-1 text-md">
                {item.points.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <section className="max-w-4xl mx-auto px-4 py-10">
        <h2 className="text-3xl font-bold text-center mb-6">
        💰✨ Eligibility to Avail a Gold Loan
        </h2>
 

      <div className="space-y-6">
        {/* Age Requirement */}
        <div className="flex items-start gap-4 bg-gray-100 dark:bg-gray-800 p-4 rounded-xl shadow-sm">
          <FaUser className="text-xl text-yellow-600 mt-1" />
          <div>
            <h3 className="font-semibold text-gray-800 dark:text-white">Age Requirement</h3>
            <p className="text-gray-600 dark:text-gray-300">
              The borrower must be at least 18 years old and not older than 75 years at the time of loan maturity.
            </p>
          </div>
        </div>

        {/* Ownership of Gold */}
        <div className="flex items-start gap-4 bg-gray-100 dark:bg-gray-800 p-4 rounded-xl shadow-sm">
          <FaIdCard className="text-xl text-yellow-600 mt-1" />
          <div>
            <h3 className="font-semibold text-gray-800 dark:text-white">Ownership of Gold</h3>
            <p className="text-gray-600 dark:text-gray-300">
              The borrower must be the legal owner of the gold ornaments or coins being pledged.
            </p>
          </div>
        </div>

        {/* Employment & Income Proof */}
        <div className="flex items-start gap-4 bg-gray-100 dark:bg-gray-800 p-4 rounded-xl shadow-sm">
          <FaBriefcase className="text-xl text-yellow-600 mt-1" />
          <div>
            <h3 className="font-semibold text-gray-800 dark:text-white">Employment & Income Proof</h3>
            <p className="text-gray-600 dark:text-gray-300">
              Unlike personal loans, gold loans do not require proof of income or employment,
              making them accessible to self-employed individuals, homemakers, and students.
            </p>
          </div>
        </div>

        {/* Credit Score */}
        <div className="flex items-start gap-4 bg-gray-100 dark:bg-gray-800 p-4 rounded-xl shadow-sm">
          <FaStar className="text-xl text-yellow-600 mt-1" />
          <div>
            <h3 className="font-semibold text-gray-800 dark:text-white">Credit Score</h3>
            <p className="text-gray-600 dark:text-gray-300">
              While a credit score is not a major factor, a good credit history can lead to better loan terms.
            </p>
          </div>
        </div>
      </div>
    </section>
   
    {/* <section className="max-w-7xl mx-auto px-4 py-10">
      <h2 className="text-3xl font-bold text-center mb-6">
        Why Choose a Gold Loan? (Comparison with Personal Loan)
      </h2>

      <div className="overflow-x-auto rounded-lg shadow border border-gray-200 dark:border-gray-700">
        <table className="min-w-full table-auto text-left">
          <thead className="bg-gray-100 dark:bg-gray-800">
            <tr>
              <th className="px-4 py-3 font-semibold text-gray-700 dark:text-white">Feature</th>
              <th className="px-4 py-3 font-semibold text-gray-700 dark:text-white">Gold Loan</th>
              <th className="px-4 py-3 font-semibold text-gray-700 dark:text-white">Personal Loan</th>
            </tr>
          </thead>
          <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
            <tr>
              <td className="px-4 py-3 font-medium text-gray-800 dark:text-white">Collateral</td>
              <td className="px-4 py-3 text-gray-600 dark:text-gray-300">Gold jewelry required</td>
              <td className="px-4 py-3 text-gray-600 dark:text-gray-300">No collateral required</td>
            </tr>
            <tr>
              <td className="px-4 py-3 font-medium text-gray-800 dark:text-white">Interest Rate</td>
              <td className="px-4 py-3 text-gray-600 dark:text-gray-300">7% - 29%</td>
              <td className="px-4 py-3 text-gray-600 dark:text-gray-300">10% - 24%</td>
            </tr>
            <tr>
              <td className="px-4 py-3 font-medium text-gray-800 dark:text-white">Loan Approval Time</td>
              <td className="px-4 py-3 text-gray-600 dark:text-gray-300">1 - 2 hours</td>
              <td className="px-4 py-3 text-gray-600 dark:text-gray-300">1 - 3 days</td>
            </tr>
            <tr>
              <td className="px-4 py-3 font-medium text-gray-800 dark:text-white">Credit Score Requirement</td>
              <td className="px-4 py-3 text-gray-600 dark:text-gray-300">Not mandatory</td>
              <td className="px-4 py-3 text-gray-600 dark:text-gray-300">750+ preferred</td>
            </tr>
            <tr>
              <td className="px-4 py-3 font-medium text-gray-800 dark:text-white">Loan Tenure</td>
              <td className="px-4 py-3 text-gray-600 dark:text-gray-300">Up to 5 years</td>
              <td className="px-4 py-3 text-gray-600 dark:text-gray-300">Up to 7 years</td>
            </tr>
          </tbody>
        </table>
      </div>
    </section> */}
 <section className="max-w-7xl mx-auto px-4 py-10">
  <h2 className="text-3xl font-bold text-center mb-6">
    Why Choose a Gold Loan? (Comparison with Personal Loan)
  </h2>

  {/* Desktop Table View */}
  <div className="hidden md:block overflow-x-auto rounded-lg shadow border border-gray-200 dark:border-gray-700">
    <table className="min-w-full table-auto text-left">
      <thead className="bg-gray-100 dark:bg-gray-800">
        <tr>
          <th className="px-4 py-3 font-semibold text-gray-700 dark:text-white">Feature</th>
          <th className="px-4 py-3 font-semibold text-gray-700 dark:text-white">Gold Loan</th>
          <th className="px-4 py-3 font-semibold text-gray-700 dark:text-white">Personal Loan</th>
        </tr>
      </thead>
      <tbody className="bg-white dark:bg-gray-900 divide-y divide-gray-200 dark:divide-gray-700">
        <tr>
          <td className="px-4 py-3 font-medium text-gray-800 dark:text-white">Collateral</td>
          <td className="px-4 py-3 text-gray-600 dark:text-gray-300">Gold jewelry required</td>
          <td className="px-4 py-3 text-gray-600 dark:text-gray-300">No collateral required</td>
        </tr>
        <tr>
          <td className="px-4 py-3 font-medium text-gray-800 dark:text-white">Interest Rate</td>
          <td className="px-4 py-3 text-gray-600 dark:text-gray-300">7% - 29%</td>
          <td className="px-4 py-3 text-gray-600 dark:text-gray-300">10% - 24%</td>
        </tr>
        <tr>
          <td className="px-4 py-3 font-medium text-gray-800 dark:text-white">Loan Approval Time</td>
          <td className="px-4 py-3 text-gray-600 dark:text-gray-300">1 - 2 hours</td>
          <td className="px-4 py-3 text-gray-600 dark:text-gray-300">1 - 3 days</td>
        </tr>
        <tr>
          <td className="px-4 py-3 font-medium text-gray-800 dark:text-white">Credit Score Requirement</td>
          <td className="px-4 py-3 text-gray-600 dark:text-gray-300">Not mandatory</td>
          <td className="px-4 py-3 text-gray-600 dark:text-gray-300">750+ preferred</td>
        </tr>
        <tr>
          <td className="px-4 py-3 font-medium text-gray-800 dark:text-white">Loan Tenure</td>
          <td className="px-4 py-3 text-gray-600 dark:text-gray-300">Up to 5 years</td>
          <td className="px-4 py-3 text-gray-600 dark:text-gray-300">Up to 7 years</td>
        </tr>
      </tbody>
    </table>
  </div>

  {/* Mobile Card View */}
  <div className="md:hidden space-y-4">
    {[
      {
        feature: "Collateral",
        gold: "Gold jewelry required",
        personal: "No collateral required",
      },
      {
        feature: "Interest Rate",
        gold: "7% - 29%",
        personal: "10% - 24%",
      },
      {
        feature: "Loan Approval Time",
        gold: "1 - 2 hours",
        personal: "1 - 3 days",
      },
      {
        feature: "Credit Score Requirement",
        gold: "Not mandatory",
        personal: "750+ preferred",
      },
      {
        feature: "Loan Tenure",
        gold: "Up to 5 years",
        personal: "Up to 7 years",
      },
    ].map((item, index) => (
      <div key={index} className="border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm p-4 bg-white dark:bg-gray-900">
        <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">{item.feature}</h3>
        <div className="flex justify-between py-1">
          <span className="text-gray-600 dark:text-gray-300 font-medium">Gold Loan:</span>
          <span className="text-gray-700 dark:text-gray-200 text-right">{item.gold}</span>
        </div>
        <div className="flex justify-between py-1">
          <span className="text-gray-600 dark:text-gray-300 font-medium">Personal Loan:</span>
          <span className="text-gray-700 dark:text-gray-200 text-right">{item.personal}</span>
        </div>
      </div>
    ))}
  </div>
</section>

      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 ">
          <h1 className="text-3xl font-bold text-blue-700 mb-4">
          Pros & Cons of Gold Loan
          </h1>
          <p className="text-gray-700 mb-6">✅ Pros:</p>

          {points.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 ">
          <h1 className="text-3xl font-bold text-blue-700 mb-4">
            Cons of a Gold Loan
          </h1>
          <p className="text-gray-700 mb-6">❌ Cons</p>

          {points1.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className=" px-2 p-6 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h1 className="text-3xl font-bold text-blue-700 mb-4">

          How to Choose the Right Gold Loan         </h1>
          <p className="text-gray-700 mb-6">
          Choosing the right gold loan is crucial to ensuring that you get the best deal with minimal financial burden. A gold loan can be a convenient way to meet short-term financial needs, but selecting the right lender and loan terms is essential for a hassle-free borrowing experience. Here are the key factors to consider when choosing a gold loan:
          </p>

          {points3.map((item, index) => (
            <div
              key={index}
              className="p-5 mb-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {item.title}
              </h2>
              <ul className="list-disc list-inside text-gray-600 mt-2">
                {item.points.map((point, idx) => (
                  <li key={idx} className="mt-1">
                    ✔ {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      {/* FAQ section */}
      <div className="max-w-4xl mx-auto py-6 p-6">
        <h1 className="text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default GoldLoanNew;
